import React, {useState} from 'react';
import i18next from 'i18next';
import {useTranslation} from 'react-i18next';
import {styles} from './styles';
import {commonStyles as stylesCommon} from '../../styles/common';

function Index() {
    const {t, i18n} = useTranslation();
    const [open, setOpen] = useState(false);
    const commonStyles = stylesCommon(); 
    const lang = i18n.language;

    const langLabel = lang === 'en' ? 'ENG' : 'ESP';

    return (
       <div style={styles.content}>
            {open &&
                <div className='changeLangDropDown' style={styles.dropdown}>
                    <div 
                        onClick={
                            ()=> [
                                i18next.changeLanguage('es'),
                                setOpen(false)
                            ]
                        } 
                        style={styles.dropdownItem}
                    >
                        <img 
                            style={styles.iconsSmall}
                            src={require('../../assets/icons/spanish.png')} />
                        <p style={styles.text}>ESP</p>
                    </div>
                    <div 
                        onClick={
                            ()=> [
                                i18next.changeLanguage('en'),
                                setOpen(false)
                            ]
                        }
                        style={styles.dropdownItem}
                    >
                         <img 
                            style={styles.iconsSmall}
                            src={require('../../assets/icons/english.png')}/>
                        <p style={styles.text}>ENG</p>
                    </div>
                </div>
            }

            <div onClick={()=> setOpen(!open)} style={styles.pillButton}>
                <p style={styles.pillText}>{langLabel}</p>
                <img 
                    style={styles.pillIcon}
                    src={
                        lang === 'en' ?
                            require('../../assets/icons/english.png')
                            : 
                            require('../../assets/icons/spanish.png')
                    } />
            </div>
            
       </div>
    );
}

export default Index;

